import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types.tsx';
import type { IssueKey, ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import type { ChildIssuesPanelType, SortOption } from '../../types.tsx';
import { generateChildIssuesJQL } from '../generate-child-issues-jql/index.tsx';
import { generateNinBasePath } from '../generate-nin-base-path/index.tsx';

export const generateViewInSearchLink = (
	projectKey: ProjectKey,
	projectType: ProjectType,
	isSimplifiedProject: boolean,
	parentKey: IssueKey,
	childIssuesPanelType: ChildIssuesPanelType,
	hasExceededIssuesLimitInitialLoad: boolean,
	sortByValue: SortOption | null = null,
) =>
	`${generateNinBasePath()}?${generateChildIssuesJQL(
		parentKey,
		childIssuesPanelType,
		hasExceededIssuesLimitInitialLoad,
		sortByValue || undefined,
	)}`;
